export function currencyFormat(value : number) {
    const price = value / 100;
    return price ? price.toLocaleString('pt-br', { minimumFractionDigits: 2 }) : ''
}